import './note-search.scss';

import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';

export interface INoteSearchProps {
  placeholder?: string;
  onSearch?: (searchText: string) => void;
}

export const NoteSearch = ({
  placeholder = 'Search notes...',
  onSearch,
}: INoteSearchProps) => {
  const [searchText, setSearchText] = useState<string>('');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchText);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClearText = () => {
    setSearchText('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <Box className="note-search-container">
      <TextField
        variant="outlined"
        placeholder={placeholder}
        size="small"
        fullWidth
        className="note-search-field"
        value={searchText}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchText && (
                <IconButton
                  aria-label="clear text"
                  onClick={handleClearText}
                  className="clear-button"
                  size="small"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <Button className="search-button" onClick={handleSearch}>
                SEARCH
              </Button>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
